import React, { Component } from 'react'

import Repository from '../../felles/repository'
import { FormGroup, ControlLabel, Modal, FormControl, Button } from 'react-bootstrap'
import { resolve } from '../../dependencies'

export default class NyMaalerType extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fabrikatTyper: [],
            typer: [],
            dimensjon: [],
            retning: [],
            kapasitet: [],
            tekst: '',
            valgtFabrikat: '',
            valgtType: '',
            valgtDimensjon: '',
            valgtKapasitet: '',
            valgtRetning: '',
            valgtSiffer: '',
            valgtTemp: '',
            maalernummerPrefix:'',
            brukerLora: false,
            visModal: true
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleChangeFabrikat = this.handleChangeFabrikat.bind(this)
        this.handleChangeType = this.handleChangeType.bind(this)
        this.handleChangeDimensjon = this.handleChangeDimensjon.bind(this)
        this.handleChangeRetning = this.handleChangeRetning.bind(this)
        this.handleChangeSiffer = this.handleChangeSiffer.bind(this)
        this.handleChangeTemp = this.handleChangeTemp.bind(this)
        this.handleChangeKapasitet = this.handleChangeKapasitet.bind(this)
        this.handleChangeMaalernummerPrefix = this.handleChangeMaalernummerPrefix.bind(this)
        this._submit = this._submit.bind(this)
        this._lukkModal = this._lukkModal.bind(this)
    }

    getValidationState() {
        const length = this.state.tekst.length
        if (length <= 0) return 'error'
        else if (length > 1) return 'success'
    }
    handleChange(e) {
        this.setState({ tekst: e.target.value })
    }
    handleChangeFabrikat(e) {
        this.setState({ valgtFabrikat: e.target.value })
    }

    handleChangeType(e) {
        this.setState({ valgtType: e.target.value })
    }
    handleChangeDimensjon(e) {
        this.setState({ valgtDimensjon: e.target.value })
    }
    handleChangeKapasitet(e) {
        this.setState({ valgtKapasitet: e.target.value })
    }
    handleChangeRetning(e) {
        this.setState({ valgtRetning: e.target.value })
    }

    handleChangeSiffer(e) {
        this.setState({ valgtSiffer: e.target.value })
    }
    handleChangeTemp(e) {
        this.setState({ valgtTemp: e.target.value })
    }

    handleChangeMaalernummerPrefix(e) {
        this.setState({ valgtMaalernummerPrefix: e.target.value })
    }

    handleLora(e) {
        var forrigeVerdi = this.state.brukerLora
        this.setState({ brukerLora: !forrigeVerdi })
    }

    componentDidMount() {
        console.log(this.props)
        this.setState({
            fabrikatTyper: this.props.fabrikat,
            typer: this.props.typer,
            dimensjon: this.props.dimensjon,
            retning: this.props.retning,
            tekst: this.props.tekst,
            kapasitet: this.props.kapasitet,
            valgtFabrikat: this.props.fabrikatId,
            valgtType: this.props.typeId,
            valgtDimensjon: this.props.dimensjonId,
            valgtRetning: this.props.retningId,
            valgtSiffer: this.props.antallSiffer,
            valgtTemp: this.props.temp,
            valgtKapasitet: this.props.kapasitetId,
            valgtMaalernummerPrefix: this.props.maalernummerPrefix,
            brukerLora: this.props.brukerLora,
            visModal: true
        })

        if (this.props.id === '') {
            this.setState({
                valgtFabrikat: this.props.fabrikat[0].Id,
                valgtType: this.props.typer[0].Id,
                valgtDimensjon: this.props.dimensjon[0].Id,
                valgtRetning: this.props.retning[0].Id,
                valgtKapasitet: this.props.kapasitet[0].Id,
                valgtTemp: this.props.Temperatur,
                valgtSiffer: '0',
                valgtMaalernummerPrefix: ''
            })
        }
    }

    _submit(event) {
        event.preventDefault()
        let KundeId = window.sessionStorage.getItem('kundeId')

        if (this.state.tekst === '') {
            return
        }

        let egendefObj = {
            Id: this.props.id,
            KundeId: KundeId,
            Tekst: this.state.tekst,
            FabrikatId: this.state.valgtFabrikat,
            TypeId: this.state.valgtType,
            DimensjonId: this.state.valgtDimensjon,
            RetningId: this.state.valgtRetning,
            Temperatur: this.state.valgtTemp,
            Kapasitet: this.state.valgtKapasitet,
            Antallsiffer: this.state.valgtSiffer,
            MaalernummerPrefix: this.state.valgtMaalernummerPrefix,
            BrukerLora: this.state.brukerLora
        }

        if (this.props.id === '') {
            resolve(Repository).leggTilEgendefinerteMaalertype(egendefObj).then(this._lukkModal)
        } else {
            resolve(Repository).oppdaterTilEgendefinerteMaalertype(egendefObj).then(this._lukkModal)
        }     
    }

    _lukkModal(){        
        this.props.onClose()
    }

    render() {
        console.log(this.state.brukerLora)
        return (
            <Modal show={this.props.isOpen} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Forhåndsdefinert måler</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={this._submit} id="formId">
                        <FormGroup controlId="tekstId" validationState={this.getValidationState()}>
                            <ControlLabel>Tittel</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Skriv noe"
                                onChange={this.handleChange}
                                value={this.state.tekst}
                            />
                        </FormGroup>

                        <FormGroup controlId="fabId">
                            <ControlLabel>Fabrikat</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="Velg fabrikat"
                                onChange={this.handleChangeFabrikat}
                                value={this.state.valgtFabrikat}
                            >
                                {this.state.fabrikatTyper.map((st, index) => (
                                    <option key={st.Id} value={st.Id}>
                                        {st.Tekst}
                                    </option>
                                ))}
                            </FormControl>
                        </FormGroup>

                        <FormGroup controlId="typeId">
                            <ControlLabel>Type</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="Velg type"
                                onChange={this.handleChangeType}
                                value={this.state.valgtType}
                            >
                                {this.state.typer.map((st, index) => (
                                    <option key={st.Id} value={st.Id}>
                                        {st.Tekst}
                                    </option>
                                ))}
                            </FormControl>
                        </FormGroup>

                        <FormGroup controlId="dimensjonId">
                            <ControlLabel>Dimensjon</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="Velg dimensjon"
                                onChange={this.handleChangeDimensjon}
                                value={this.state.valgtDimensjon}
                            >
                                {this.state.dimensjon.map((st, index) => (
                                    <option key={st.Id} value={st.Id}>
                                        {st.Tekst}
                                    </option>
                                ))}
                            </FormControl>
                        </FormGroup>

                        <FormGroup controlId="retningId">
                            <ControlLabel>Retning</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="Velg retning"
                                onChange={this.handleChangeRetning}
                                value={this.state.valgtRetning}
                            >
                                {this.state.retning.map((st, index) => (
                                    <option key={st.Id} value={st.Id}>
                                        {st.Tekst}
                                    </option>
                                ))}
                            </FormControl>
                        </FormGroup>

                        <FormGroup controlId="tempId">
                            <ControlLabel>Temperatur</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="Velg temperatur"
                                onChange={this.handleChangeTemp}
                                value={this.state.valgtTemp}
                            >
                                <option key="kId" value="0">
                                    Kaldt vann
                                </option>
                                <option key="vId" value="1">
                                    Varmt vann
                                </option>
                            </FormControl>
                        </FormGroup>

                        <FormGroup controlId="sifferId">
                            <ControlLabel>Antall siffer</ControlLabel>
                            <FormControl
                                type="number"
                                placeholder="Skriv antall siffer"
                                onChange={this.handleChangeSiffer}
                                value={this.state.valgtSiffer}
                            />
                        </FormGroup>
                        
                            <FormGroup controlId="kapasitetId">
                                <ControlLabel>Kapasitet</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    placeholder="Velg kapasitet"
                                    onChange={this.handleChangeKapasitet}
                                    value={this.state.valgtKapasitet}
                                >
                                    {this.state.kapasitet.map((st, index) => (
                                        <option key={st.Id} value={st.Id}>
                                            {st.Tekst}
                                        </option>
                                    ))}
                                </FormControl>
                            </FormGroup>
                        
                        <FormGroup controlId="maalernummerPrefix">
                            <ControlLabel>Målernummer prefix</ControlLabel>
                            <FormControl
                                type="input"
                                placeholder="Skriv målernummer prefix"
                                onChange={this.handleChangeMaalernummerPrefix}
                                value={this.state.valgtMaalernummerPrefix}
                            />
                        </FormGroup>

                        <FormGroup controlId="kommunikasjon">
                            <ControlLabel>Kommunikasjon</ControlLabel>
                            {/* <FormControl
                                type="radio"       
                                label="Lora"                         
                                onChange={this.handleChangeMaalernummerPrefix}
                                value={this.state.valgtMaalernummerPrefix} */}
                            <br/>
                            
                            <input type="checkbox" name="lora" id="lora" 
                            
                            checked={this.state.brukerLora} onChange={this.handleLora.bind(this)}/> Lora <br/>
                        </FormGroup>
                        
                        <Button bsStyle="success" type="submit">
                            OK
                        </Button>
                    </form>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/innstillinger/maalertyper/maalertyperModal.jsx